export const FETCH_PRACTITIONAR_REQUEST = "FETCH_PRACTITIONAR_REQUEST";
export const FETCH_PRACTITIONAR_SUCCESS = "FETCH_PRACTITIONAR_SUCCESS";
export const FETCH_PRACTITIONAR_FAILURE = "FETCH_PRACTITIONAR_FAILURE";
